export default __webpack_public_path__ + "static/media/force-update.e77f8cde.svg";